module.exports = __webpack_public_path__ + "img/Lithuania.28d69881.png";